import * as React from "react";
import { TextInput, NumberInput, Create, required, AutocompleteArrayInput, ReferenceArrayInput } from "react-admin";
import { FaqCreateComponent } from "./";
import Transformer from "../../common/Transformer";
import { TinyMCEContentInput } from "src/components/input";
import { Grid } from "@mui/material";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";

export const FaqCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["categoryIds"],
      update: {
        categories: data["category_ids"]
      }
    });

    return data;
  };

  return (
    <Create component={FaqCreateComponent} transform={transform}>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12}>
              <TextInput source="question" validate={required()} />
            </Grid>
            <Grid item sm={12}>
              <NumberInput source="sort_order" />
            </Grid>
            <Grid item sm={12}>
              <TinyMCEContentInput source="answer" fullWidth required base64></TinyMCEContentInput>
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Categories" name="categories">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <ReferenceArrayInput
                source="category_ids"
                reference="admin/faq/categories"
                children={
                  <AutocompleteArrayInput
                    optionText="name"
                    size="small"
                    sx={{ minWidth: "35vw" }}
                  />
                }
              />
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
